<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12">
        <!-- Page Header -->
        <v-row align="center" justify="center" class="mt-n4">
          <v-col cols="12" md="auto">
            <div class="d-flex align-center justify-center">
              <v-avatar color="primary" size="52" class="mr-3 elevation-2">
                <v-icon color="white" size="28">mdi-file-document-outline</v-icon>
              </v-avatar>
              <div>
                <div class="text-h5 font-weight-bold grey--text text--darken-2">Cotizaciones</div>
                <div class="text-caption grey--text">Revisa y edita cotizaciones</div>
              </div>
            </div>
          </v-col>
        </v-row>

        <!-- Filters -->
        <v-row justify="center">
          <v-col cols="12">
            <search-header-po @dataFilters="changeBusiness($event)" :show_location="false" />
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="order_filtered"
          :search="search"
          :loading="loading"
          loading-text="Cargando cotizaciones..."
          class="elevation-1 mt-4 rounded-lg"
          show-expand
          :expanded.sync="expanded"
          item-key="id"
          @item-expanded="loadDetails"
          :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100], itemsPerPageText: 'Filas por página' }"
          :items-per-page="25"
        >
          <template v-slot:top>
            <v-toolbar class="rounded-lg" flat>
              <v-toolbar-title>
                <span>Cotizaciones: {{ order_filtered.length }}</span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                class="text-xs-center"
                v-model="search"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details
                outlined
                dense
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-col md="2">
                <v-autocomplete
                  class="mt-6"
                  dense
                  outlined
                  v-model="selectedStatus"
                  :items="status"
                  item-text="name"
                  item-value="value"
                  color="cyanText"
                  label="Estatus"
                  required
                ></v-autocomplete>
              </v-col>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" :disabled="!lastFilterData || loading" @click="refreshData" class="ml-1">
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>Recargar</span>
              </v-tooltip>
            </v-toolbar>
          </template>

          <template v-slot:[`item.id`]="{ item }">
            <v-hover v-slot="{ hover }">
              <span
                @click="ViewGroup(item)"
                class="font-weight-semibold"
                :style="{
                  color: hover ? '#1565C0' : '#1976D2',
                  cursor: 'pointer',
                  'text-decoration': hover ? 'underline' : 'none',
                  'font-family': 'monospace',
                  'font-size': '13px'
                }"
              >{{ filLeft(item.id.toString(), 12, "0") }}</span>
            </v-hover>
          </template>

          <template v-slot:[`item.order_id`]="{ item }">
            <v-hover v-slot="{ hover }">
              <span
                v-if="item.order_id"
                @click="showOrder(item.order_id, false)"
                :style="{
                  color: hover ? '#1565C0' : '#1976D2',
                  cursor: 'pointer',
                  'text-decoration': hover ? 'underline' : 'none',
                  'font-family': 'monospace',
                  'font-size': '13px',
                  'font-weight': 600
                }"
              >{{ filLeft(item.order_id.toString(), 12, "0") }}</span>
              <span v-else class="grey--text text--lighten-1">—</span>
            </v-hover>
          </template>

          <template v-slot:[`item.created_at`]="{ item }">
            <span class="caption">{{ getDate(item.created_at) }}</span>
          </template>

          <template v-slot:[`item.item_count`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on" style="min-width: 90px">
                  <div class="d-flex align-center justify-space-between mb-1">
                    <span class="caption font-weight-bold" :class="item.priced_count == item.total_pairs && item.total_pairs > 0 ? 'green--text text--darken-1' : 'orange--text text--darken-2'">
                      {{ item.priced_count }}/{{ item.total_pairs }}
                    </span>
                    <v-icon x-small :color="item.priced_count == item.total_pairs && item.total_pairs > 0 ? 'green darken-1' : 'orange darken-2'">
                      mdi-tag-check-outline
                    </v-icon>
                  </div>
                  <v-progress-linear
                    :value="item.total_pairs > 0 ? (item.priced_count / item.total_pairs) * 100 : 0"
                    :color="item.priced_count == item.total_pairs && item.total_pairs > 0 ? 'success' : 'warning'"
                    height="5"
                    rounded
                    background-color="grey lighten-3"
                  ></v-progress-linear>
                </div>
              </template>
              <span>{{ item.priced_count }} de {{ item.total_pairs }} precios completados ({{ item.item_count }} artícs. × {{ item.supplier_count }} supls.)</span>
            </v-tooltip>
          </template>

          <template v-slot:[`item.supplier_count`]="{ item }">
            <v-chip x-small color="deep-purple lighten-5" text-color="deep-purple darken-2" class="font-weight-bold px-2">
              <v-icon left x-small class="mr-1">mdi-store-outline</v-icon>
              {{ item.supplier_count }}
            </v-chip>
          </template>

          <template v-slot:[`item.bussines_unit_description`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on" class="d-inline-block text-truncate" style="max-width: 200px; vertical-align: middle">
                  {{ item.bussines_unit_description }}
                </span>
              </template>
              <span>{{ item.bussines_unit_description }}</span>
            </v-tooltip>
          </template>

          <template v-slot:[`item.status_id`]="{ item }">
            <div class="stat-chip" :class="item.order_id ? 'status-ordered' : 'status-pending'" v-if="item.status_id == 1">
              <v-icon size="13" color="white" class="chip-icon">mdi-{{ item.order_id ? 'check-circle' : 'clock-outline' }}</v-icon>
              <span class="chip-label">{{ item.order_id ? 'Ordenada' : 'Pendiente' }}</span>
            </div>
            <div class="stat-chip status-cancelled" v-else>
              <v-icon size="13" color="white" class="chip-icon">mdi-close-circle</v-icon>
              <span class="chip-label">Cancelada</span>
            </div>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="pa-0">
              <v-card flat class="mx-3 my-2 rounded-lg" color="grey lighten-5">
                <v-card-text class="pa-3">
                  <div v-if="loadingDetails[item.id]" class="d-flex align-center justify-center py-4">
                    <v-progress-circular indeterminate color="primary" size="24" width="2"></v-progress-circular>
                    <span class="ml-3 caption grey--text">Cargando artículos...</span>
                  </div>
                  <div v-else-if="expandedItems[item.id] && expandedItems[item.id].length">
                    <v-simple-table dense class="rounded elevation-0 expanded-table">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left caption grey--text text--darken-1">Artículo</th>
                            <th class="text-left caption grey--text text--darken-1">Cód. Prov.</th>
                            <th class="text-center caption grey--text text--darken-1">Cant.</th>
                            <th class="text-left caption grey--text text--darken-1">Unidad</th>
                            <th class="text-left caption grey--text text--darken-1">Proveedor</th>
                            <th class="text-right caption grey--text text--darken-1">Precio</th>
                            <th class="text-left caption grey--text text--darken-1">Ubicación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(detail, idx) in expandedItems[item.id]" :key="idx" class="detail-row">
                            <td class="caption font-weight-medium">{{ detail.item_name }}</td>
                            <td class="caption grey--text text--darken-1">{{ detail.item_code_supplier || '—' }}</td>
                            <td class="caption text-center">
                              <v-chip x-small color="blue lighten-5" text-color="blue darken-3" class="font-weight-bold">{{ detail.quotation_detail_quantity }}</v-chip>
                            </td>
                            <td class="caption grey--text">{{ detail.unit_name }}</td>
                            <td class="caption">{{ detail.supplier_name }}</td>
                            <td class="caption text-right">
                              <span v-if="detail.price" class="green--text text--darken-1 font-weight-medium">{{ formatAmount(detail.price) }}</span>
                              <span v-else class="grey--text text--lighten-1 caption">Sin precio</span>
                            </td>
                            <td class="caption grey--text">{{ detail.location_description }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </div>
                  <div v-else class="text-center caption grey--text py-3">
                    <v-icon size="20" class="mr-1">mdi-information-outline</v-icon>Sin detalles disponibles
                  </div>
                </v-card-text>
              </v-card>
            </td>
          </template>

          <template v-slot:[`item.actions_col`]="{ item }">
            <v-tooltip bottom v-if="item.status_id == 1 && hasFeature('SHOP-052')">
              <template v-slot:activator="{ on }">
                <v-btn icon x-small color="error" v-on="on" @click.stop="confirmCancel(item)">
                  <v-icon small>mdi-close-circle-outline</v-icon>
                </v-btn>
              </template>
              <span>Cancelar cotización</span>
            </v-tooltip>
          </template>

          <template v-slot:no-data>
            <v-row justify="center" class="pt-10">
              <v-icon size="60px" :color="hasLoaded ? 'grey lighten-1' : 'blue lighten-3'">
                {{ hasLoaded ? 'mdi-magnify-close' : 'mdi-filter-outline' }}
              </v-icon>
            </v-row>
            <v-row justify="center" class="pb-6 mt-2">
              <span class="grey--text">
                {{ hasLoaded ? 'No hay cotizaciones con los filtros seleccionados' : 'Selecciona una unidad de negocio para ver las cotizaciones' }}
              </span>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
      <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dark color="primary">
            <!-- <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn> -->
            <v-toolbar-title>Cotizacion {{ editedItem.id }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon dark @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text class="mt-4">
            <QuotesGroupsVue :quote="editedItem.id" />
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="cancelDialog" max-width="420" persistent>
        <v-card class="rounded-lg">
          <v-card-title class="text-h6 pt-5 pb-2">
            <v-icon color="error" class="mr-2">mdi-alert-circle-outline</v-icon>
            Cancelar cotización
          </v-card-title>
          <v-card-text v-if="cancellingItem" class="pb-2">
            ¿Estás seguro de que deseas cancelar la cotización
            <strong>{{ cancellingItem.id }}</strong>? Esta acción no se puede deshacer.
          </v-card-text>
          <v-card-actions class="pb-4 px-4">
            <v-spacer></v-spacer>
            <v-btn text @click="cancelDialog = false" :disabled="loading">Volver</v-btn>
            <v-btn color="error" depressed @click="cancelQuote" :loading="loading">Cancelar cotización</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import QuotesGroupsVue from "@/components/Shop/QuotesGroups.vue";
export default {
  data: () => ({
    dialog: false,
    editedIndex: -1,
    editedItem: {},
    expanded: [],
    expandedItems: {},
    loadingDetails: {},
    loading: false,
    hasLoaded: false,
    lastFilterData: null,
    cancelDialog: false,
    cancellingItem: null,
    headers: [
      { text: "Cotización", align: "start", value: "id", width: "140px" },
      { text: "Progreso", value: "item_count", align: "center", width: "120px", sortable: true },
      { text: "Provs.", value: "supplier_count", align: "center", width: "70px", sortable: true },
      { text: "Orden", value: "order_id", width: "140px" },
      { text: "Unidad de negocio", value: "bussines_unit_description" },
      { text: "Fecha", value: "created_at", width: "155px" },
      { text: "Usuario", value: "user_fullname" },
      { text: "Estatus", value: "status_id", align: "center", width: "120px", sortable: false },
      { text: "", value: "actions_col", align: "center", width: "40px", sortable: false },
    ],
    search: "",
    selectedStatus: 1,
    status: [
      { name: "Todas", value: 0 },
      { name: "Pendientes", value: 1 },
      { name: "Ordenadas", value: 2 },
      { name: "Canceladas", value: 3 },
    ],
    data: [],
  }),
  components: { QuotesGroupsVue },
  created() {
   // this.getInitialData();
  },
    computed: {
      order_filtered() {
        if (this.selectedStatus === 0) return this.data;
        if (this.selectedStatus === 1) return this.data.filter((o) => o.status_id == 1 && o.order_id === null);
        if (this.selectedStatus === 2) return this.data.filter((o) => o.status_id == 1 && o.order_id !== null);
        if (this.selectedStatus === 3) return this.data.filter((o) => o.status_id == 2);
        return this.data;
      },
  },
  methods: {
    getDate(date) {
      let newDate = moment(date).format("DD-MM-YYYY HH:mm A").toString();
      return newDate;
    },
    ViewGroup(item) {
      this.$router.push({ name: "ViewQuoteGroup", params: { id: item.id, is_order: item.order_id !== null } });
    },
    formatAmount(val) {
      if (!val) return "—";
      return parseFloat(val).toLocaleString("es-DO", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    async loadDetails({ item, value }) {
      if (!value || this.expandedItems[item.id] !== undefined) return;
      this.$set(this.loadingDetails, item.id, true);
      try {
        const numericId = parseInt(item.id, 10);
        const res = await this.api_Get(`shopping/quotesDetails/${numericId}`);
        const rows = await res.json();
        this.$set(this.expandedItems, item.id, Array.isArray(rows) ? rows : []);
      } catch (e) {
        this.$set(this.expandedItems, item.id, []);
      } finally {
        this.$set(this.loadingDetails, item.id, false);
      }
    },
    confirmCancel(item) {
      this.cancellingItem = item;
      this.cancelDialog = true;
    },
    async cancelQuote() {
      if (!this.cancellingItem) return;
      this.loading = true;
      try {
        const numericId = parseInt(this.cancellingItem.id, 10);
        await this.api_Post("shopping/cancel_quote_group", { id: numericId });
        const idx = this.data.findIndex((o) => o.id === this.cancellingItem.id);
        if (idx !== -1) this.$set(this.data[idx], "status_id", 2);
        this.cancelDialog = false;
        this.cancellingItem = null;
        this.refreshStatusCounts();
      } catch (e) {
        console.error("Error al cancelar cotización:", e);
      } finally {
        this.loading = false;
      }
    },
    refreshStatusCounts() {
      this.status = [
        { name: `Todas (${this.data.length})`, value: 0 },
        { name: `Pendientes (${this.data.filter((o) => o.order_id === null && o.status_id != 2).length})`, value: 1 },
        { name: `Ordenadas (${this.data.filter((o) => o.order_id !== null && o.status_id != 2).length})`, value: 2 },
        { name: `Canceladas (${this.data.filter((o) => o.status_id == 2).length})`, value: 3 },
      ];
    },
    async refreshData() {
      if (!this.lastFilterData) return;
      await this.changeBusiness(this.lastFilterData);
    },
    async changeBusiness(data) {
      this.lastFilterData = data;
      this.loading = true;
      let filters = "WHERE BUSINESS_UNIT_ID=" + data.business;
      filters += data.dateStart != null ? (" AND created_at::DATE BETWEEN " + `'${data.dateStart}'` + " AND " + `'${data.dateEnd}'`) : "";
      try {
        const request = await this.api_Post("shopping/list_quotes", { filters });
        this.data = await request.json();
        this.expanded = [];
        this.expandedItems = {};
        this.loadingDetails = {};
        this.hasLoaded = true;
        this.refreshStatusCounts();
      } catch (e) {
        console.error("Error al cargar cotizaciones:", e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.stat-chip {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  max-height: 22px;
  line-height: 1;
  vertical-align: middle;
  color: #fff;
  letter-spacing: 0.3px;
}

.status-ordered {
  background-color: #43a047;
}

.status-pending {
  background-color: #fb8c00;
}

.status-cancelled {
  background-color: #e53935;
}

.chip-icon {
  margin-right: 4px;
  font-size: 13px;
  height: 14px;
  width: 14px;
  color: #fff !important;
}

.expanded-table {
  background-color: transparent !important;
}

.expanded-table thead tr th {
  background-color: #f5f5f5 !important;
  font-size: 11px !important;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 6px 12px !important;
}

.expanded-table tbody tr.detail-row:hover {
  background-color: #e8eaf6 !important;
}

.expanded-table tbody tr.detail-row td {
  padding: 6px 12px !important;
  border-bottom: 1px solid #eeeeee;
}
</style>
